var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommentBase',{attrs:{"added-by":_vm.comment.addedBy,"text":_vm.formattedCommentText,"subtitle":_vm.comment.getDateCreatedTimestamp(),"type":_vm.comment.type}})}
var staticRenderFns = []

export { render, staticRenderFns }